<template>
  <b-modal
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    @hide="handleHide"
    @hidden="$emit('hidden')"
    title="Proposer une ouverture"
    hide-footer
    centered
    size="xl"
  >
    <b-form @submit.prevent="submit">

      
      <b-form-group label="Date de l'ouverture">
        <b-form-datepicker
          v-model="form.date"
          :min="minDate"
          :max="maxDate"
          :date-disabled-fn="isDateDisabled"
          required
          placeholder="Sélectionner une date"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group>
        <div class="d-flex align-items-center">
          <hr class="flex-grow-1" />
        </div>
      </b-form-group>


      <b-form-group label="Créneaux (min. 2)">
        <div
          v-for="(event, index) in form.events"
          :key="index"
          class="d-flex align-items-center mb-2"
          
        >
          <HourMinutePicker
            v-model="event.time"
            class="mr-2 add-opening-time-input"
            @change="sortEvents"
          />
          <b-form-select
            v-model="event.type"
            :options="eventTypes"
            required
            class="mr-2"
          ></b-form-select>
          <b-button
            variant="outline-danger"
            size="sm"
            @click="removeEvent(index)"
            :disabled="form.events.length <= 2"
          >
            Supprimer
          </b-button>
        </div>
        <b-button variant="outline-primary" size="sm" @click="addEvent">
          + Ajouter un event
        </b-button>
      </b-form-group>

      <b-form-group>
        <div class="d-flex align-items-center">

          <hr class="flex-grow-1" />
        </div>
      </b-form-group>

      <b-form-group label="Description (optionnel)">
        <b-form-textarea
          v-model="form.description"
          placeholder="Décrivez brièvement l'ouverture"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <br>
      <div class="text-right mt-4">
        <b-button variant="secondary" @click="$emit('update:visible', false)">Annuler</b-button>
        <b-button type="submit" variant="primary" class="ml-2">Créer l'ouverture</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import OpeningService from "@/services/opening.service";
import ApiService from "@/services/api.service";
import HourMinutePicker from "@/components/HourMinutePicker.vue";

export default {
  name: 'AddOpeningModal',
  components: {
    HourMinutePicker
  },
  props: {
    visible: Boolean,
    existingDates: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        date: null,
        description: "",
        events: [
          { time: "12:00:00", type: "ouverture" },
          { time: "18:00:00", type: "fermeture" }
        ]
      },
      eventTypes: [
        { value: "ouverture", text: "Ouverture" },
        { value: "fermeture", text: "Fermeture" }
      ],
      seasonEndDate: null
    };
  },
  async created() {
    try {
      const res = await ApiService.get("/saison/actuelle");
      const fin = res && res.data && res.data.fin_saison;
      if (fin) {
        this.seasonEndDate = fin.split("T")[0];
      }
    } catch {
      // pas de saison active, pas de max
    }
  },
  computed: {
    minDate() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    blockedDatesSet() {
      return new Set(this.existingDates.filter(Boolean));
    },
    maxDate() {
      return this.seasonEndDate || undefined;
    }
  },
  methods: {
    handleHide() {
      this.$emit("update:visible", false);
    },
    isDateDisabled(ymd) {
      return this.blockedDatesSet.has(ymd);
    },
    addEvent() {
      this.form.events.push({ time: null, type: "ouverture" });
    },
    removeEvent(index) {
      if (this.form.events.length <= 2) {
        return;
      }
      this.form.events.splice(index, 1);
    },
    sortEvents() {
      this.form.events.sort((a, b) => {
        const aTime = a.time || "";
        const bTime = b.time || "";
        return aTime.localeCompare(bTime);
      });
    },
    async submit() {
      
      this.sortEvents();
      if (this.form.date && this.blockedDatesSet.has(this.form.date)) {
        alert("Une ouverture existe déjà pour cette date.");
        return;
      }

      const payload = {
        date: this.form.date,
        description: this.form.description,
        events: this.form.events,
        openingType: "MEMBER_OPENING"
      };

      try {
        const response = await OpeningService.create(payload);
        const data = response.data;

        if (response && response.data) {
          this.$emit("update:visible", false);
          this.$emit("created", data.id);
        } else {
          alert(`Erreur : ${data.error || data.message}`);
        }
      } catch (err) {
        console.error("Erreur serveur :", err);
        alert("Erreur lors de la création de l'ouverture.");
      }
    }
  }
};
</script>

<style scoped>
.add-opening-time-input {
  width: 160px;
  flex: 0 0 160px;
}
</style>
